<template>
  <div class="w-100 overflow-y-auto">
    <div class="container">
      <h2 class="text-center mb-4">
        {{ $t("notificacao") }}
      </h2>
      <NotificacaoForm class="mb-4" media="" :video="false" :active="true" @enviar-notificacao="onEnviarNotificacao" />
    </div>
  </div>
</template>

<script>
import NotificacaoForm from './NotificacaoForm.vue';
import { enviarNotificacao } from '../notificacaoService';
import { useToast } from 'vue-toastification';
export default {
  components: { NotificacaoForm },
  methods: {
    async onEnviarNotificacao(notificacao) {
      try {
        const response = await enviarNotificacao(notificacao);
        if (response) {
          useToast().success('Notificação enviada com sucesso.');
        } else {
          useToast().error(response);
        }
      } catch (error) {
        useToast().error('Erro de conexão');
      }
    },
  },
};
</script>
